import { Component, DoCheck, Input, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { DomSanitizer } from '@angular/platform-browser';
import { translate } from '@ngneat/transloco';
import { CommonUtilsService } from '../../services/commonutils/common-utils.service';
import { UtilsService } from '../../services/utils/utils.service';

@Component({
    selector: 'app-messagepopup',
    templateUrl: './messagepopup.component.html',
    styleUrls: ['./messagepopup.component.scss'],
    standalone: false,
})
export class MessagePopupComponent implements OnInit, DoCheck {
    @Input() message: any[];
    @Input() messageType: string;
    @Input() showErrorIcon: boolean;

    @ViewChild('errorMessagesTrigger', {
        static: false,
        read: MatMenuTrigger,
    })
    private errorMessagesMenuTrigger: MatMenuTrigger;
    private currentMessage: any[];
    public currentMessageString: string;

    constructor(private Sanitizer: DomSanitizer, protected _libUtils: UtilsService, private _commonUtils: CommonUtilsService) {}

    ngDoCheck() {
        if (JSON.stringify(this.message) !== JSON.stringify(this.currentMessage)) {
            this.currentMessageString = undefined;
            setTimeout(() => {
                this.setMessage();
            });
        }
    }

    private setMessage = () => {
        let string = '';
        if (this.message) {
            for (let i = 0; i < this.message.length; i++) {
                if (i > 0) {
                    string += '<br>';
                }
                string += i + 1 + '. ' + this.message[i];
            }
            this.currentMessage = this.message;
            this.currentMessageString = this.Sanitizer && this.Sanitizer.sanitize(SecurityContext.HTML, string);
        }
    };

    public copyMessagesToClipboard = () => {
        this._commonUtils.copyTextToClipboard(
            this.message || (this.showErrorIcon && !this.currentMessageString && translate('Errors found in sub-section(s)')),
            () => {
                this._libUtils.alertSuccess('Successfully copied');
            },
            () => {
                this._libUtils.alertError('Failed to copy');
            }
        );
    };

    public closeMessagesMenu = (messageType: string) => {
        switch (messageType) {
            case 'errors':
                this.errorMessagesMenuTrigger.closeMenu();
                break;
        }
    };

    ngOnInit() {
        this.setMessage();
    }
}
